import { FormControlLabel, Switch } from '@mui/material';
export const NeedSentimentalAnalisys = ({ needSentimentalAnalisys, onChangeSwitch }) => {
  const handleChange = (event) => {
    onChangeSwitch(event);
  };

  return (
    <FormControlLabel
      control={
        <Switch
          name="needSentimentalAnalisys"
          checked={needSentimentalAnalisys}
          onChange={handleChange}
          color="primary"
        />
      }
      label="¿Necesita análisis sentimental?"
    />
  );
};
